import React from "react";
import CommonModal from "../../../../components/Common/CommonModal";
import CommonButton from "../../../../components/buttons/CommonButton";
import { handleChange } from "../../../../helpers/handleFormChanges";
import CommonInputDate from "../../../../components/forms/CommonInputDate";
import { hoje } from "../../../../helpers/mesesHelper";
import PropTypes from "prop-types";

function SubstituirHonorarioModal({
  modalHook,
  valuesHook,
  substituirHonorario,
}) {
  const { substituirHonorarioModal, setSubstituirHonorarioModal } = modalHook;
  const { values, setValues } = valuesHook;

  return (
    <CommonModal
      title="Substituir mensalidade"
      is_open_modal={substituirHonorarioModal}
      set_is_open_modal={setSubstituirHonorarioModal}
      size="lg"
      buttons={
        <CommonButton
          key={`substituir-honorario`}
          onClick={substituirHonorario}
          color="success"
        >
          Substituir
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonInputDate
            label="Data de vencimento"
            id="vencimento"
            value={values.vencimento}
            min={hoje.toISOString().split("T")[0]}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required
          />
        </div>
      </div>
    </CommonModal>
  );
}

SubstituirHonorarioModal.propTypes = {
  modalHook: PropTypes.shape({
    substituirHonorarioModal: PropTypes.bool.isRequired,
    setSubstituirHonorarioModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  substituirHonorario: PropTypes.func.isRequired,
};

export default SubstituirHonorarioModal;
